import { useState } from 'react';
import { DialogContent, FormControlLabel } from '@material-ui/core';
import PropTypes from 'prop-types';

import { CUSTOM_BUTTON_COLOR, CUSTOM_BUTTON_VARIANT } from 'src/components/CustomButton';
import { CustomCheckbox } from 'src/components/CustomCheckbox';
import { CustomDialog } from 'src/components/CustomDialog';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { GENERATION_TOOL, getToolTitle } from 'src/data/generationTool';

import { useStyles } from './useStyles';

export const TemplateFoundPopup = ({
  open,
  generationTool,
  onSubmit,
  onClose,
  displayBackButton,
}) => {
  const styles = useStyles();

  const [dontShowAgain, setDontShowAgain] = useState(false);
  const templateName = getToolTitle(generationTool);

  const handleSubmit = () => {
    onSubmit({ generationTool, dontShowAgain });
  };
  const handleCancel = () => {
    onSubmit({ generationTool: null, dontShowAgain });
  };

  return (
    <CustomDialog
      className={styles.root}
      classes={{ buttonSubmit: styles.buttonSubmit }}
      open={open}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      onClose={onClose}
      onBack={onClose}
      title="Template found"
      submitLabel="Yes, take me there"
      cancelLabel="No thanks, I want to use the prompt"
      cancelProps={{ variant: CUSTOM_BUTTON_VARIANT.contained, color: CUSTOM_BUTTON_COLOR.silver }}
      displayBackButton={displayBackButton}
      data-testid="popupTemplateFound"
      displayCloseIcon
    >
      <DialogContent className={styles.dialogContent}>
        <CustomTypography
          className={styles.description}
          variant={TYPOGRAPHY_VARIANT.regular16}
        >
          We found a relevant template for your prompt – {templateName}.
        </CustomTypography>

        <FormControlLabel
          className={styles.dontShowAgain}
          control={
            <CustomCheckbox
              checked={dontShowAgain}
              onChange={() => setDontShowAgain((prev) => !prev)}
              color="primary"
            />
          }
          label={
            <CustomTypography variant={TYPOGRAPHY_VARIANT.regular14}>
              Don&apos;t show me this again
            </CustomTypography>
          }
        />
      </DialogContent>
    </CustomDialog>
  );
};

TemplateFoundPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  displayBackButton: PropTypes.bool,
};
TemplateFoundPopup.defaultProps = {
  displayBackButton: false,
};
